<template>
    <svg width="12" height="12" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#x8dlgjbg8a)">
            <path
                d="m9.15 6.008 2.73-1.781c.08-.05.12-.13.12-.22s-.05-.17-.12-.22L6.15.045a.272.272 0 0 0-.3 0L.12 3.787c-.07.05-.12.13-.12.22s.05.17.12.22l2.73 1.78L.12 7.788c-.07.05-.12.13-.12.22s.05.17.12.22l5.73 3.732s.1.04.15.04c.05 0 .11-.02.15-.04l5.73-3.732c.08-.05.12-.13.12-.22s-.05-.17-.12-.22l-2.73-1.78zM6 10.87 1.61 8.008l2.15-1.4 2.08 1.36s.1.04.15.04c.05 0 .11-.02.15-.04l2.08-1.36 2.15 1.4-4.39 2.862H6z"
            />
        </g>
        <defs>
            <clipPath id="x8dlgjbg8a">
                <path fill="#fff" d="M0 0h12v12H0z" />
            </clipPath>
        </defs>
    </svg>
</template>
